export default __webpack_public_path__ + "static/media/medications.bbd2f544.png";